<template>
  <div>
    <v-row justify="center">
      <v-dialog
        v-model="this.$store.state.showDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <template v-slot:activator="{ on }">
          <slot></slot>
        </template>
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="toggleDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <!-- <v-toolbar-title>Settings</v-toolbar-title> -->
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="saveRecord"> Save </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-divider></v-divider>

          <v-form class="py-4 mx-auto" style="max-width: 700px">
            <v-toolbar dense flat>
              <v-overflow-btn
                :items="search_type"
                dense
                label="Search By"
                hide-details
              ></v-overflow-btn>

              <v-text-field
                v-model="tin"
                color="cyan darken"
                label="Tax Identification Number"
                placeholder="Start typing..."
                loading
                class="mt-3"
              >
                <template v-slot:progress>
                  <v-progress-linear
                    v-if="custom"
                    :value="progress"
                    :color="color"
                    absolute
                    height="7"
                  ></v-progress-linear>
                </template>
                <template v-slot:append>
                  <v-btn text block><v-icon>mdi-account-search</v-icon></v-btn>
                </template>
              </v-text-field>
            </v-toolbar>

            <v-text-field
              v-model="tin"
              color="cyan darken"
              label="Tax Identification Number"
              placeholder="Start typing..."
              loading
            >
              <template v-slot:progress>
                <v-progress-linear
                  v-if="custom"
                  :value="progress"
                  :color="color"
                  absolute
                  height="7"
                ></v-progress-linear>
              </template>
              <template v-slot:append>
                <v-btn text block><v-icon>mdi-account-search</v-icon></v-btn>
              </template>
            </v-text-field>
            <v-row>
              <v-col cols="12">
                <v-alert :type="alertType" dense dismissible>{{
                  message
                }}</v-alert>
              </v-col>
            </v-row>
            <v-text-field
              v-model="name"
              label="TaxPayer's Name"
              single-line
              outlined
              ref="name"
            ></v-text-field>

            <v-text-field
              v-model="phone_number"
              label="Phone Number"
              single-line
              outlined
              ref="phone_number"
            ></v-text-field>
            <!-- <v-text-field
                      v-model="taxResult.gross_income"
                      label="Gross Income"
                      single-line
                      outlined
                      v-currency="{currency: 'NGN', locale: 'en'}"
                      readonly
                      ref="gross_income"
                    ></v-text-field>
                    <v-text-field
                      v-model="taxResult.tax_deductions"
                      :label="tax.taxDeductions"
                      single-line
                      outlined
                      v-currency="{currency: 'NGN', locale: 'en'}"
                      readonly
                      ref="tax_deductions"
                    ></v-text-field>
                    <v-text-field
                      v-model="taxResult.tax_relief"
                      :label="tax.taxRelief"
                      single-line
                      outlined
                      v-currency="{currency: 'NGN', locale: 'en'}"
                      readonly
                      ref="tax_relief"
                    ></v-text-field>
                    <v-text-field
                      v-model="taxResult.tax_due"
                      label="Tax Due"
                      single-line
                      outlined
                      v-currency="{currency: 'NGN', locale: 'en'}"
                      readonly
                      ref="tax_due"
                    ></v-text-field> -->
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "SaveAssessmentDialog",
  props: ["tax"],
  data() {
    return {
      dialog: true,
      name: "",
      tin: "",
      phone_number: "",
      custom: true,
      message: "Hello Uchenna",
      alertType: "success",
      search_type: [{ text: "TIN" }, { text: "Customer Name" }],
      dropdown_edit: [
        { text: "100%" },
        { text: "75%" },
        { text: "50%" },
        { text: "25%" },
        { text: "0%" },
      ],
    };
  },
  computed: {
    progress() {
      return Math.min(100, this.tin.length * 10);
    },
    color() {
      return ["error", "warning", "success"][Math.floor(this.progress / 40)];
    },
  },
  methods: {
    toggleDialog() {
      this.$store.dispatch("changeSaveAssessmentDialog", false);
    },
    fetchAssessmentByTin() {},
    saveRecord() {
      //  const api = "https://www.taxclearance.by.gov.ng/RevenueHouseApi/v1";
      const api = "https://localhost:5001/api";
      const data = {
        name: this.name,
        tin: this.tin,
        phone_number: this.phone_number,
        gross: this.tax.grossIncome,
        tax_deductions: this.tax.taxDeductions,
        tax_due: this.tax.taxDue,
        tax_relief: this.tax.taxRelief,
      };

      const vm = this;

      axios({
        url: `${api}/assessment`,
        data,
        method: "POST",
      })
        .then(function(res) {
          if (res && res.data.code == 0) {
            setTimeout(() => {
              vm.isValidating = true;
              vm.showError(res.data.message);
            }, 1000);
          } else if (res && res.data.code == 1) {
            vm.receipt = res.data.content;
            setTimeout(() => {
              vm.isValidating = false;
              vm.overlay = false;
            }, 1000);
          }
        })
        .catch(function() {});
    },
  },
};
</script>
